import { Component, ComponentInterface, Event, EventEmitter, h, Host, Method, Prop } from "@stencil/core";

let id = 0;

@Component({
    tag: "uic-switch",
    styleUrl: "switch.scss"
})
export class Switch implements ComponentInterface {
    private labelId: string;
    private inputId: string;

    private input: HTMLInputElement;

    /**
     * If set to `true`, the user cannot interact with the switch.
     */
    @Prop({ reflect: true }) readonly disabled: boolean = false;

    /**
     * If set to `true`, the switch is considered "on".
     */
    @Prop({ reflect: true, mutable: true }) checked = false;

    /**
     * The label.
     */
    @Prop() readonly label: string;

    /**
     * Emitted when the switch is toggled.
     */
    @Event() uicChange: EventEmitter;

    componentWillLoad() {
        this.inputId = `uic-switch-input-${++id}`;
        this.labelId = `uic-switch-label-${id}`;
    }

    /**
     * Sets focus on the switch.
     * @param options The focus options
     */
    @Method()
    async setFocus(options?: FocusOptions) {
        this.input.focus(options);
    }

    /**
     * Removes focus from the switch.
     */
    @Method()
    async removeFocus() {
        this.input.blur();
    }

    private handleChange() {
        const checked = this.input.checked;
        if (this.checked !== checked) {
            this.checked = checked;
            this.uicChange.emit();
        }
    }

    render() {
        return (
            <Host
                class={{
                    "uic-switch": true,
                    "uic-switch--checked": this.checked,
                    "uic-switch--disabled": this.disabled,
                    "uic-switch--has-label": !!this.label
                }}
            >
                <label class='uic-switch__label' htmlFor={this.inputId}>
                    <div id={this.labelId} class='uic-switch__label-slot'>
                        <slot>{this.label}</slot>
                    </div>
                    <input
                        class='uic-switch__input'
                        id={this.inputId}
                        ref={(el) => (this.input = el)}
                        type='checkbox'
                        role='switch'
                        checked={this.checked}
                        disabled={this.disabled}
                        onChange={() => this.handleChange()}
                        aria-labelledby={this.labelId}
                    />
                    <div class='uic-switch__track'>
                        <div class='uic-switch__thumb'></div>
                    </div>
                </label>
            </Host>
        );
    }
}
